module.exports = {"131171201":"大麻森乡","131171400":"高新技术产业开发区","131171401":"新型功能材料产业园","131171402":"苏正"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131171.json
// module id = 340
// module chunks = 0